import React from 'react';
import { ApolloProvider, Query } from 'react-apollo';
import gql from 'graphql-tag';
import SuccessionPlanningGenerator from '../components/Succession/SuccessionPlanningGenerator';
import ErrorBoundary from '../components/ErrorBoundary';
import client from '../lib/apolloClient';
import SuccessionThemeProvider from '../components/Succession/SuccessionThemeProvider';

// GraphQL query to get Succession Planning form data
const GET_SUCCESSION_PLANNING_DATA = gql`
  query GetSuccessionPlanningFormData {
    getCurrentUser {
      id
      succession_planning_form_datum {
        id
        user_id
        formData
        currentSection
        sectionCount
        completionPercentage
        status
        welcomeShown
        aiInsights {
          key_strengths
          identified_risks
          action_recommendations
          compliance_status
          emotional_readiness_score
          financial_readiness_score
          overall_readiness_score
        }
      }
    }
  }
`;

// Simple loading spinner component with theming
const SimpleLoadingSpinner = () => (
  <div className="flex justify-center items-center min-h-[200px] bg-succession-bg-secondary">
    <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-succession-primary"></div>
  </div>
);

const SuccessionPlanningGeneratorContainer = (props, railsContext) => {
  console.log('SuccessionPlanningGeneratorContainer - Props:', props);
  console.log('SuccessionPlanningGeneratorContainer - RailsContext:', railsContext);
  
  // Extract company data for theming (following same pattern as SuccessionDashboardContainer)
  const companyData = props?.company || {
    id: railsContext?.company_id,
    name: railsContext?.company_name,
    host: railsContext?.company_host,
    primary_color: props?.primary_color,
    secondary_color: props?.secondary_color,
    neutral_color: props?.neutral_color,
    accent_color: props?.accent_color,
  };

  console.log('SuccessionPlanningGeneratorContainer - Company data for theming:', companyData);

  return (
    <ApolloProvider client={client}>
      <SuccessionThemeProvider 
        company={companyData}
        user={props?.current_user}
      >
        <ErrorBoundary>
          <Query query={GET_SUCCESSION_PLANNING_DATA}>
            {({ loading, error, data }) => {
              if (loading) return <SimpleLoadingSpinner />;
              if (error) return (
                <div className="min-h-screen bg-succession-bg-secondary p-6">
                  <div className="max-w-2xl mx-auto bg-succession-bg-primary rounded-lg p-6 border border-succession-border">
                    <div className="text-succession-error text-center">
                      Error loading Succession Planning data: {error.message}
                    </div>
                  </div>
                </div>
              );
              
              const successionPlanningData = data?.getCurrentUser?.succession_planning_form_datum || null;
              
              return (
                <SuccessionPlanningGenerator 
                  successionPlanningData={successionPlanningData}
                  company={companyData}
                  current_user={props?.current_user}
                />
              );
            }}
          </Query>
        </ErrorBoundary>
      </SuccessionThemeProvider>
    </ApolloProvider>
  );
};

export default SuccessionPlanningGeneratorContainer; 